'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OrganicSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrganicSvg(props) {
    var width = props.width,
        height = props.height,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { width: width, height: height, viewBox: '0 0 24 27', xmlns: 'http://www.w3.org/2000/svg', role: 'img', 'aria-labelledby': 'fullimgOrganic', 'data-hook': 'wixrest-menus-icon-full-organic' },
        _react2.default.createElement(
            'title',
            { id: 'fullimgOrganic' },
            i18n.get('openrest_menubuilderv3_dishlabels_organic') || 'organic'
        ),
        _react2.default.createElement('path', {
            d: 'M15.96 11.97c-1.33 1.237-1.564 3.218-.654 4.716-.594.813-1.02 1.63-1.304 2.292-.476-.935-1.225-2.23-2.213-3.506 1.134-1.967.94-4.512-.677-6.268C7.36 5.13.013 5 .013 5s-.41 7.4 3.313 11.44c1.87 2.032 4.94 2.244 7.09.602-.897-1.175-2.207-2.555-4.016-3.682-.282-.175-.368-.544-.192-.825.13-.21.365-.31.595-.276-.054.258.06.53.305.655 4.017 2.034 6.394 7.808 6.417 7.867.008.02.02.033.03.05.01.022.023.042.037.063.03.043.065.08.105.114.014.01.024.024.04.034.057.042.122.07.19.09l.013.005c.045.01.09.016.137.016h.006c.074 0 .144-.016.21-.04.005-.003.01-.002.014-.004.016-.006.025-.018.04-.025.048-.025.092-.052.132-.088.02-.02.037-.04.054-.06.03-.033.054-.07.075-.11.014-.027.025-.052.035-.08.005-.018.017-.033.022-.052.01-.038.97-3.87 4.158-5.59.236-.126.343-.387.296-.637.292-.092.61.04.735.33.128.305-.014.656-.32.785-1.177.5-2.08 1.516-2.725 2.483 1.357.695 3.054.522 4.237-.578C23.908 14.83 24 9.622 24 9.622s-5.2-.29-8.04 2.348',
            fill: primaryColor })
    );
}

OrganicSvg.displayName = 'OrganicSvg';
OrganicSvg.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
OrganicSvg.defaultProps = {
    width: 24,
    height: 27,
    primaryColor: '#228f73'
};